import { Button, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { Country } from 'entities/countries/model/types';
import { SignUpFormData } from 'pages/auth/registration/model/types';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PhoneInput, { PhoneInputState } from 'shared/ui/PhoneInput/PhoneInput';

type Props = {
  countries: Country[];
  formRules: Record<string, Rule[]>;
  formData: Partial<SignUpFormData>;
};

export const PhoneSection: FC<Props> = ({ countries, formData }) => {
  const { formatMessage: t } = useIntl();
  const [form] = Form.useForm();
  const [forceShowErrors, setForceShowErrors] = useState(false);
  
  const phoneCountries = countries.filter(
    (country) => country.eea || country.iso2 === 'GB'
  );

  const phoneValue: PhoneInputState | undefined = formData.phone
    ? {
        countryCode: formData.phone.countryCode,
        phoneNumber: formData.phone.phoneNumber,
        haveErrors: false,
      }
    : undefined;

  useEffect(() => {
    if (formData.phone) {
      const currentValue = form.getFieldValue('phone');
      if (!currentValue ||
          currentValue.countryCode !== formData.phone.countryCode || 
          currentValue.phoneNumber !== formData.phone.phoneNumber) {
        const phoneState: PhoneInputState = {
          countryCode: formData.phone.countryCode,
          phoneNumber: formData.phone.phoneNumber,
          haveErrors: currentValue?.haveErrors ?? false,
        };
        form.setFieldsValue({ phone: phoneState });
      }
    }
  }, [form, formData.phone]);

  const handleSubmit = async () => {
    setForceShowErrors(true);
    try {
      await form.validateFields();
    } catch (error) {
    }
  };

  return (
    <Form 
      form={form} 
      name="phone"
      onFinish={handleSubmit}
    >
      <Form.Item
        name="phone"
        validateTrigger={['onSubmit']}
        hasFeedback={false}
        rules={[
          {
            validator: (_, value) => {
              if (!value || value.haveErrors) {
                return Promise.reject(
                  new Error(t({ id: 'schemas.validation.phone.invalid' }))
                );
              }
              return Promise.resolve();
            },
          },
        ]}
        initialValue={phoneValue}
      >
        <PhoneInput
          countries={phoneCountries}
          onChange={(state) => form.setFieldValue('phone', state)}
          forceShowErrors={forceShowErrors}
          value={phoneValue}
        />
      </Form.Item>

      <Form.Item>
        <Button 
          color="primary" 
          variant="solid" 
          htmlType="submit" 
          block
        >
          {t({ id: 'buttons.next' })}
        </Button>
      </Form.Item>
    </Form>
  );
};
